<div mat-dialog-title>
  <div>{{ note ? 'Update' : 'Create' }} Site Note</div>
  <div (click)="onNoClick()" class="close-icon-container">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div class="edit-note-form" mat-dialog-content>
  <form [formGroup]="editSiteNote">
    <mat-form-field>
      <mat-select formControlName="category" data-cy="note-category" placeholder="Note Category">
        @for (category of categories; track category) {
          <mat-option [value]="category">
            {{ category }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="full-width" data-cy="note-text" subscriptSizing="dynamic">
      <mat-label>Note Text</mat-label>
      <textarea formControlName="note" matInput placeholder="Details" rows="4"></textarea>
    </mat-form-field>
    <mat-checkbox data-cy="needs-review-checkbox" formControlName="needsReview">Flag for Review</mat-checkbox>
  </form>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="false" color="primary" data-cy="button-cancel" mat-stroked-button>Cancel</button>
  <button
    (click)="onSubmit()"
    [disabled]="editSiteNote.invalid"
    color="primary"
    data-cy="button-submit"
    mat-raised-button>
    Save
  </button>
</div>
